import { ILoginData, IRegisterData } from "../types/user";
import { BACKEND_URL, getHeaders, handleResponse } from "./utils";

export async function registerUser(userData: IRegisterData) {
  const url = `${BACKEND_URL}/users/signup`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(userData),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
}

export async function loginUser(loginData: ILoginData) {
  const url = `${BACKEND_URL}/auth/login`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(loginData),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error logging in user:", error);
    throw error;
  }
}
